<script>
import { mapActions, mapState } from 'vuex'
import utils from '@/utils'
import _ from 'lodash'

const commonRules = {
  'required-field': {
    required: true,
    message: 'To pole jest wymagane.',
    trigger: 'blur'
  }
}

export default {
  name: 'in-touch',
  data () {
    var validateApi = (rule, value, callback, source, options) => {
      if (this.errors[ rule.field ]) {
        this.errors[ rule.field ].forEach(function (message) {
          callback(message)
        })
        delete this.errors[ rule.field ]
      } else {
        callback()
      }
    }

    return {
      message: {},
      errors: [],
      formChanged: false,
      rules: {
        email: [
          { type: 'email', message: 'Niepoprawny format adresu email.' }
        ],
        content: [
          commonRules[ 'required-field' ],
          { validator: validateApi, trigger: 'blur' }
        ]
      }
    }
  },
  updated () {
    this.formChanged = true
  },
  computed: {
    ...mapState([ 'cartMessages' ]),
    messages () {
      this.cartMessages.forEach((message) => {
        message.teaser = _.truncate(message.content, { length: 250, separator: /\S+\s*/g })
      })
      return this.cartMessages
    }
  },
  methods: {
    ...mapActions(['aIntouchMessageCreate']),
    handleSubmitMessage () {
      this.$refs.message.validate((valid) => {
        if (valid) {
          this.message.title = 'Wiadomość ze strony'
          this.aIntouchMessageCreate(this.message)
            .then(() => {
              this.message = {}
              this.$emit('update:visible', false)
            })
            .catch((err) => {
              this.errors = utils.keysToCamel(err.body)
              this.$refs.message.validate()
              return false
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<template>
  <el-main>
    <el-row class="message-form">
      <el-form
        ref="message"
        size="small"
        label-width="auto"
        :model="message"
        :rules="rules"
      >
        <el-form-item label="imię i nazwisko">
          <el-input
            size="mini"
            placeholder="imię i nazwisko"
            v-model="message.fullName"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="email">
          <el-input
            size="mini"
            placeholder="twój@addres.email"
            v-model="message.email"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="nr telefonu"
          label-position="top"
        >
          <el-input
            size="mini"
            placeholder="+48..."
            v-model="message.phone"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="wiadomość">
          <el-input
            size="mini"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 20}"
            placeholder="Napisz do nas..."
            v-model="message.content"
          >
          </el-input>
        </el-form-item>
        <el-form-item align="right">
          <el-button
            size="mini"
            type="primary"
            @click="handleSubmitMessage()"
          >Wyślij wiadomość</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </el-main>
</template>



// WEBPACK FOOTER //
// src/components/site-message.vue